export const EDIT = '@/EDIT';
export const WIZARD = '@/WIZARD';
